export const someFieldObjectIsNull = (obj?: Record<string, string | null>): boolean => {
  if (!obj) return true
  return Object.values(obj).some((elem) => elem === null)
}
